export default [{
  path: '/summary',
  name: 'summary',
  meta: {
    title: "考满分路上的奋斗清单",
    requiresAuth: false,
  },
  component: () =>
    import( /* webpackChunkName: 'summary' */ './content-page/index.vue')
},
{
  path: '/home-summary',
  name: 'home-personal',
  meta: {
    title: "考满分路上的奋斗清单",
    requiresAuth: false,
  },
  component: () =>
    import( /* webpackChunkName: 'home-personal' */ './home-page/index.vue')
},
]